import { useEffect, useState } from "react";
import Container from "../../components/layout/Container/Container";
import LabGrid from "./LabGrid";
import { getAllLabApplication } from "../../api/apimethods";
import Header from "../../components/molecules/Header/Header";
import Footer from "../../components/molecules/Footer/Footer";
import Loader from "../../components/molecules/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { NotifyType } from "../../utils/NotifyType";
import { notify } from "../../utils";
import { useNavigate, Form, useLocation } from "react-router-dom";
const LabDashboard = () => {
  const enquiryDashboard = [
    /* {
      columnName: "S.No",
      sortKey: "",
    }, */
    {
      columnName: "Purpose code",
      sortKey: "purposeCode",
    },
    {
      columnName: "Reference Number",
      sortKey: "applicationNumber",
    },
    {
      columnName: "Laboratory Application Reference",
      sortKey: "applicationId",
    },
    {
      columnName: "Requestor Name",
      sortKey: "requestorName",
    },
    {
      columnName: "Application Date",
      sortKey: "applicationDate",
    },
    {
      columnName: "Sample Submit Date",
      sortKey: "sampleDate",
    },
    {
      columnName: "Application Status",
      sortKey: "applicationStatus",
    },

    {
      columnName: "Action",
      sortKey: "",
    },
  ];
  const location = useLocation();

  const { acknowledgmentNumber } = location.state || {};
  const [data, setData] = useState<any[]>([]);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [headers, setHeaders] = useState<any[]>(enquiryDashboard);
  const [registrationType, setRegistrationType] = useState("myself");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [showPopup, setShowPopup] = useState(false);
  const { message } = notify();
  const [showGrid, setShowGrid] = useState<boolean>(false);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [applicationNumber, setApplicationNumber] = useState<string | null>(
    null
  );
  const navigate = useNavigate();
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [serviceType, setServiceType] = useState<string | null>(null);
  const [allData, setAllData] = useState<any[]>([]);
  const [sno, setSno] = useState<number>(1);
  const getNextDay = (date: any) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate());
    return newDate.toISOString().split("T")[0];
  };
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };
  localStorage.removeItem("ismetadata");

  const filterData = (
    data: any[],
    from: string,
    to: string,
    applicationNumber: string,
    serviceType: string
  ) => {
    const fromDate = from ? new Date(from) : null;
    const toDate = to ? new Date(to) : null;

    if (fromDate) fromDate.setHours(0, 0, 0, 0);
    if (toDate) toDate.setHours(23, 59, 59, 999);

    const filtered = data.filter((item: any) => {
      const applicationDateValue = new Date(item.applicationDate);

      const isDateInRange =
        (!fromDate || applicationDateValue >= fromDate) &&
        (!toDate || applicationDateValue <= toDate);

      const isApplicationNumberMatch =
        !applicationNumber ||
        (item.applicationNumber &&
          item.applicationNumber.includes(applicationNumber));

      const isServiceTypeMatch =
        !serviceType ||
        (item.typeOfService && item.typeOfService === serviceType);

      return isDateInRange && isApplicationNumberMatch && isServiceTypeMatch;
    });

    return filtered;
  };

  const handleReset = () => {
    setShowGrid(false);
    setDateFrom("");
    setDateTo("");
    setShowError(false);
    setApplicationNumber("");
    setServiceType("");
  };
  useEffect(() => {
    if (acknowledgmentNumber) {
      setShowPopup(true);
    }
  }, [acknowledgmentNumber]);

  const closePopup = () => {
    setShowPopup(false);
    navigate(location.pathname, { replace: true, state: null });
  };
  const handleSearch = async () => {
    try {
      setSearchLoading(true);
      const getUserInfo = localStorage.getItem("app-data");
      const userInfo = JSON.parse(getUserInfo || "");
      const NRIC = userInfo?.user?.idNo || "";
      setCurrentPage(1);
      setPageLoading(true);
      const responses = await getAllLabApplication(
        NRIC,
        serviceType || null,
        applicationNumber || null,
        dateFrom || null,
        dateTo || null,
        "search"
      );
      const filteredData = responses.data;

      setFilteredData(filteredData);
      setShowGrid(filteredData.length > 0);
      if (filteredData.length === 0) {
        message(NotifyType.Info, "No Application(s) found");
      }
      setSearchLoading(false);
      setPageLoading(false);
    } catch (error) {
      console.error("Search error:", error);
      setSearchLoading(false);
      setPageLoading(false);
    }
  };

  return (
    <>
      <Header />
      <center>
        {" "}
        <h3 className="savedraft">Laboratory Application Dashboard</h3>
      </center>
      {acknowledgmentMessage && (
        <div className="info-content">
          <div className="att">
            <h3>Attention</h3>
            <br />
            <p className="attention">
              {">"} Application has been successfully Saved . Service
              Acknowledgement Number: &nbsp;
              {acknowledgmentMessage ? acknowledgmentMessage : ""}
            </p>
          </div>
        </div>
      )}
      {showPopup && (
        <div className="info-content attentionpopupmodal">
          <div className="att">
            <h3>Attention</h3>
            <button onClick={closePopup} className="attentionpopup">
              &#10005;
            </button>
            <br />

            <p className="attention">
              {">"} Application has been cancelled successfully. Service
              Acknowledgement Number: &nbsp;
              {acknowledgmentNumber ? acknowledgmentNumber : ""}
              <center>
                For more information regarding refund, please contact finance.
                <br />
                <b>Contact Email:</b>
                <a
                  href="mailto:Bhavani_SUBRAMANIAM@nparks.gov.sg"
                  className="text-decoration-none"
                >
                  Bhavani_SUBRAMANIAM@nparks.gov.sg
                </a>
                ,
                <a
                  href="mailto:Eric_TAN@nparks.gov.sg"
                  className="text-decoration-none"
                >
                  Eric_TAN@nparks.gov.sg
                </a>
              </center>
            </p>
          </div>
        </div>
      )}
      <Container>
        <div className="mt-3">
          <form>
            <div className="row">
              <div className="col-lg-12">
                <div className="col-md-11">
                  <div className="info-content">
                    <div className="row">
                      <label className="col-form-label col-lg-3">
                        This Request Is For
                      </label>

                      <div className="col-lg-8">
                        <div className="formed-check d-flex align-items-center">
                          <input
                            type="radio"
                            value="myself"
                            className="formed-check-input"
                            checked={registrationType === "myself"}
                            onChange={() => setRegistrationType("myself")}
                            required
                          />
                          <label className="col-form-label"> Myself</label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <label className="col-form-label">
                          Registered Date
                        </label>
                      </div>
                      <div className="col-lg-1">
                        <label className="col-form-label">From</label>
                      </div>
                      <div className="col-lg-3">
                        <input
                          type="date"
                          value={dateFrom}
                          className="form-control"
                          max={getTodayDate()}
                          onChange={(e) => {
                            setDateFrom(e.target.value);
                            setDateTo("");
                          }}
                          required
                        />
                      </div>
                      <div className="col-md-1">
                        <label className="col-form-label">To</label>
                      </div>
                      <div className="col-lg-3">
                        <input
                          type="date"
                          value={dateTo}
                          className="form-control"
                          onChange={(e) => setDateTo(e.target.value)}
                          min={dateFrom ? getNextDay(dateFrom) : ""}
                          required
                        />
                      </div>
                    </div>
                    {showError &&
                      (!dateFrom || !dateTo) &&
                      (dateFrom || dateTo) && (
                        <div className="row">
                          <div className="col-lg-3"></div>
                          <div className="col-lg-9">
                            <div className="error-message">
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faCircleExclamation}
                              />
                              Both 'From' and 'To' dates must be selected.
                            </div>
                          </div>
                        </div>
                      )}
                    <br />

                    <div className="row">
                      <div className="col-lg-3">
                        <label className="col-form-label">
                          Type Of Service
                        </label>
                      </div>

                      <div className="col-lg-9">
                        <div className="row mb-3">
                          <div className="formed-check col-lg-6 d-flex align-items-center">
                            <input
                              type="radio"
                              value="CAVS Laboratory Services"
                              className="formed-check-input"
                              checked={
                                serviceType === "CAVS Laboratory Services"
                              }
                              onChange={() =>
                                setServiceType("CAVS Laboratory Services")
                              }
                              required
                            />
                            <label className="col-form-label">
                              CAVS Laboratory Services
                            </label>
                          </div>

                          <div className="formed-check col-lg-6 d-flex align-items-center">
                            <input
                              type="radio"
                              value="  Plant Health Diagnostics Services"
                              className="formed-check-input"
                              checked={
                                serviceType ===
                                "Plant Health Diagnostics Services"
                              }
                              onChange={() =>
                                setServiceType(
                                  "Plant Health Diagnostics Services"
                                )
                              }
                            />
                            <label className="col-form-label">
                              Plant Health Diagnostics Services
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <label className="col-form-label">
                          Application Number
                        </label>
                      </div>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          value={applicationNumber || ""}
                          onChange={(e) => setApplicationNumber(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <button
                          type="button"
                          className={`custom-search-button ${
                            searchLoading ? "loading" : ""
                          }`}
                          onClick={() => {
                            if (
                              (!dateFrom || !dateTo) &&
                              (dateFrom || dateTo)
                            ) {
                              setShowError(true);
                            } else {
                              setShowError(false);
                              handleSearch();
                            }
                          }}
                          disabled={searchLoading}
                        >
                          {searchLoading ? "Searching..." : "Search"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleReset}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>{" "}
          <br />
          {pageLoading ? <Loader /> : null}
          {showGrid && filteredData.length > 0 && (
            <LabGrid
              data={filteredData}
              isLoading={isLoading}
              headerColumns={headers}
              setData={setData}
              allData={allData}
              sno={sno}
            />
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default LabDashboard;
